import {CombineReducers} from '@tunnel-store/index';
import createHistory from 'history/createBrowserHistory'
import {routerMiddleware} from 'react-router-redux';
import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
// import Logger from 'redux-logger';
import thunk from 'redux-thunk';

const composeEnhancers = composeWithDevTools({});
export const history = createHistory();

/**
 * Ici on défini une seule source de vérité ( le Store )
 * @export StoreTunnelWatch
 */

export const StoreTunnelWatch = createStore<any, any, {}, {}>(
    /**
     * @namespace
     * @param { any } CombineReducers   - CombineReducers contient l'ensemble
     *     des
     *                                  - reducers de l'applications
     * @name Logger                     - middleware
     * "https://github.com/LogRocket/redux-logger"
     * @name Thunk                      - middleware
     * "https://github.com/reduxjs/redux-thunk"
     */
    CombineReducers,
    composeEnhancers(applyMiddleware(
        routerMiddleware(history),
        // Logger,
        thunk)));



// WEBPACK FOOTER //
// ./src/Store/index.ts